import { lazy, Suspense, useEffect, useState } from "react";
import { Download, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { Button } from "../ui/button";
import { fetchExpenseReceipt } from "../../services/expenses";
import { apiError, saveBlob } from "./expenseUtils";
const PdfView = lazy(() => import("../employees/PdfAttachmentView").then(module => ({ default: module.PdfAttachmentView })));

export const ExpenseReceiptPreview = ({ expenseId, receipt, onClose }) => {
  const [blob, setBlob] = useState(null);
  const [url, setUrl] = useState("");
  const [error, setError] = useState("");
  useEffect(() => {
    if (!receipt) return;
    let active = true, objectUrl;
    const controller = new AbortController();
    setBlob(null); setUrl(""); setError("");
    const load = async () => {
      try {
        const data = receipt.file || (await fetchExpenseReceipt(expenseId, receipt.id, controller.signal)).data;
        if (!active) return;
        objectUrl = URL.createObjectURL(data); setBlob(data); setUrl(objectUrl);
      } catch (err) { if (active && err.code !== "ERR_CANCELED") setError(apiError(err)); }
    };
    load();
    return () => { active = false; controller.abort(); if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [expenseId, receipt]);
  return <Dialog open={!!receipt} onOpenChange={open => !open && onClose()}><DialogContent aria-describedby={undefined} className="responsive-dialog max-w-2xl max-h-[94dvh] overflow-y-auto" data-testid="expense-receipt-preview" onOpenAutoFocus={event => event.preventDefault()}>
    <DialogHeader><DialogTitle className="text-left text-base pr-6 break-words [overflow-wrap:anywhere]" data-testid="expense-receipt-preview-name">{receipt?.filename}</DialogTitle></DialogHeader>
    {error ? <p role="alert" className="text-sm text-red-600" data-testid="expense-receipt-preview-error">{error}</p> : !url ? <Loader2 className="animate-spin mx-auto my-8" data-testid="expense-receipt-preview-loading" /> : receipt?.content_type === "application/pdf" || receipt?.filename?.toLowerCase().endsWith(".pdf") ? <Suspense fallback={<Loader2 className="animate-spin mx-auto" />}><PdfView source={url} /></Suspense> : <img src={url} alt={receipt?.filename} className="w-full max-h-[60dvh] object-contain" data-testid="expense-receipt-image" />}
    <Button disabled={!blob} onClick={() => saveBlob(blob, receipt.filename)} className="min-h-11" data-testid="expense-receipt-download"><Download size={16} className="mr-2" />Télécharger</Button>
  </DialogContent></Dialog>;
};